import './HomeElectronics.css'

function HomeElectronics() {

  return (
    <div className="HomeElectronics">
      <div className="HomeElectronics-container">
        <h2>PARLANTE BLUETOOTH</h2>
        <div className="HomeElectronics-main">
          <div className="HomeElectronics-specs">
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/bluetooth.svg"} alt="" />
              <p>BLUETOOTH</p>
            </div>
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/bateria.svg"} alt="" />
              <p>5 HORAS</p>
            </div>
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/waterproof.svg"} alt="" />
              <p>RESISTENTE<br />AL AGUA</p>
            </div>
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/usb.svg"} alt="" />
              <p>CABLE<br />USB C</p>
            </div>
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/garantia.svg"} alt="" />
              <p>GARANTÍA<br />2 AÑOS</p>
            </div>
            <div className="HomeElectronics-spec">
              <img src={process.env.PUBLIC_URL + "/imgs/electronics/home/service.svg"} alt="" />
              <p>SERVICE<br />OFICIAL</p>
            </div>
          </div>
          <div className="HomeElectronics-lines">
            <div className="HomeElectronics-line">
              <h3>CLIP 5</h3>
              <div className="HomeElectronics-products">
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1086-10.png"} alt="" />
                  <p>50/1086.10</p>
                </div>
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1086-07.png"} alt="" />
                  <p>50/1086.07</p>
                </div>
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1086-03.png"} alt="" />
                  <p>50/1086.03</p>
                </div>
              </div>
            </div>
            <div className="HomeElectronics-line">
              <h3>GO 04</h3>
              <div className="HomeElectronics-products">
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1082-13.png"} alt="" />
                  <p>50/1082.13</p>
                </div>
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1082-10.png"} alt="" />
                  <p>50/1082.10</p>
                </div>
                <div className="HomeElectronics-product">
                  <img src={process.env.PUBLIC_URL + "/imgs/electronics/productos/50-1082-06.png"} alt="" />
                  <p>50/1082.06</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeElectronics;